import {Component, Injector, ViewChild} from '@angular/core';
import {DictionarySelectorDirective} from './dictionary-selector.directive';
import {Dictionary, DictionarySelector, SelectItem} from '@twpub/core/models';
import {DictionaryService} from '@twpub/core/services';
import {ComponentCategory, SessionParam} from '@twpub/core/enums';
import {BaseWrapperComponent} from '@twpub/shared/components/base';
import _ from 'lodash';

@Component({
  selector: 'pub-dictionary-wrapper',
  template: '<ng-template pubDictSelect></ng-template>',
  standalone: true,
  imports: [DictionarySelectorDirective]
})
export class DictionaryWrapperComponent extends BaseWrapperComponent<DictionarySelector> {
  override compCategory = ComponentCategory.DictionarySelector;
  override changesTriggers: SessionParam[] = [SessionParam.DICT_IDS];
  dictionaries?: Dictionary[];

  @ViewChild(DictionarySelectorDirective, {static: true}) pubDictSelect!: DictionarySelectorDirective

  constructor(injector: Injector, private dictService: DictionaryService) {
    super(injector);
  }

  override init(): void {
    this.subscriptions.add(
      this.sharedStateService.session$.subscribe(() => {
        this.dictService.getDictionaries(true).subscribe({
          next: (dicts) => {
            if (!_.isEqual(dicts, this.dictionaries)) {
              this.logger.trace('DictionaryWrapperComponent.update from session:', {
                new: JSON.stringify(dicts),
                old: JSON.stringify(this.dictionaries),
                sel: JSON.stringify(this.sharedStateService.getDictionaryIds())
              })
              this.dictionaries = dicts;
              this.update();
            }
          }
        })
      })
    )
  }

  getViewContainerRef() {
    return this.pubDictSelect.viewContainerRef;
  }

  override createComponent(): DictionarySelector {
    const comp = super.createComponent();
    comp.selectValues.subscribe((dictIds: number[]) => {
      this.logger.debug('DictionaryWrapperComponent.selectDict:' + dictIds);
      this.sharedStateService.selectDictionaries(dictIds);
    });
    return comp;
  }

  override update() {
    super.update((comp) => {
      comp.items = this.dictionaries?.map((dict) => new SelectItem(dict.id.toString(), dict.name)) || [];
      comp.selectedValues = this.sharedStateService.getDictionaryIds()?.map(id => id.toString()) || [];
      this.logger.trace('DictionaryWrapperComponent.setting in comp:', {selected: JSON.stringify(comp.selectedValues)})
    })
  }
}
